// @ts-nocheck
export const localeCodes =  [
  "en",
  "zh"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_index_46ts_c2787001",
      load: () => import("#nuxt-i18n/c2787001" /* webpackChunkName: "locale_index_46ts_c2787001" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_index_46ts_d3a40aa7",
      load: () => import("#nuxt-i18n/d3a40aa7" /* webpackChunkName: "locale_index_46ts_d3a40aa7" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US"
  },
  {
    code: "zh",
    language: "zh-CN"
  }
]
/** client **/

/** client-end **/